import { createInertiaApp } from "@inertiajs/react"
import { createElement, type ComponentType, type ReactNode } from "react"
import Layout from "@/components/Layout"

type ReactComponent = ComponentType<object>

if (typeof document !== "undefined") {
  const stored = localStorage.getItem("theme")
  if (stored === "dark") document.documentElement.classList.add("dark")
}

// Glob-import every page under ../pages so Inertia can resolve "Dashboard",
// "Projects/Index", etc. Default layout is applied here so individual pages
// don't each have to attach it.
const pageModules = import.meta.glob<{ default: ReactComponent }>("../pages/**/*.tsx", { eager: true })

void createInertiaApp({
  resolve: (name) => {
    const key = `../pages/${name}.tsx`
    const page = pageModules[key]
    if (!page) {
      throw new Error(`Inertia page not found: ${name}. Looked for ${key}`)
    }
    const component = page.default as ReactComponent & { layout?: (page: ReactNode) => ReactNode }
    component.layout ??= (children) => createElement(Layout, null, children)
    return component
  },

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => ({ queryStringArrayFormat: "brackets" }),
  },
}).catch((error) => {
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\nInertia entrypoint loaded on a non-Inertia page.",
    )
  }
})
